import * as types from "../redux/ActionTypes";

var initialState = {
  type: "",
  message: "",
};

var myReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MESSAGE:
      return { ...action.data };
    default:
      return state;
  }
};

export default myReducer;
